import React, { useState, useEffect } from 'react';
import { supabase } from 'sdk/api';
import MessageModal from 'components/shared/modals/MessageModal';
import { useSessionStorage } from 'usehooks-ts';
import useUser from 'sdk/hooks/user/useProfile';
import { useActions } from 'store/useActions';
import { useEvents } from 'hooks/useEvents';
import AppRoutes from './routes';
import 'react-lazy-load-image-component/src/effects/blur.css';
import './styles.css';
import Notification from 'components/shared/Notification';
import SalesModal from 'components/shared/modals/SalesModal/SalesModal';
import { useSalesModal } from 'components/shared/modals/SalesModal/useSalesModal';
import { useSessionManager } from 'sdk/hooks/useSessionManager';
import LanguageSwitcher from 'modules/app/components/LanguageSwitcher';
import i18n from 'i18n';

function App() {
  const [showModal, setShowModal] = useState<any>(null);
  const [showModalStorage, setShowModalStorage] = useSessionStorage<any>('showModal', null);
  const [, setSignUpClosed] = useSessionStorage<any>('signUpClosed', null);
  const { data: profile } = useUser();
  const { setIsBecomeOnline, setIsBecomeOffline, setIsSlideChange } = useActions();
  const { isModalOpen, closeModal } = useSalesModal();

    useEffect(() => {
    const savedLang = localStorage.getItem('lang') || 'en';
    i18n.changeLanguage(savedLang);
    document.documentElement.lang = savedLang;
    document.documentElement.id = savedLang === 'ar' ? 'html-arabic' : '';

    document.documentElement.dir = savedLang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.classList.toggle('arabic-font', savedLang === 'ar');

  }, []);

  
  useSessionManager();

  useEffect(() => {
    supabase.auth.onAuthStateChange(event => {
      if (event === 'SIGNED_OUT') {
        sessionStorage.clear();
        setSignUpClosed(false);
      }
    });
  }, [showModalStorage]);

  useEffect(() => {
    if (showModalStorage) {
      setShowModal(showModalStorage);
      setShowModalStorage(null);
    }
  }, [showModalStorage]);

  useEffect(() => {
    // @ts-ignore
    if (analytics) {
      // @ts-ignore
      analytics.identify(profile?.id, {
        username: profile?.username,
        email: profile?.email,
        phone: profile?.phone,
        birthday: profile?.birthday,
        country: profile?.country,
        city: profile?.city,
        region: profile?.region,
      });
    }
  }, [profile]);

  useEffect(() => {
    const expertVerificationSubmissions = supabase
      .channel('supabase_realtime')
      .on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'expert_verification_submissions',
          filter: `user_id=eq.${profile?.id}`,
        },
        payload => {
          // @ts-ignore
          if (analytics) {
            // @ts-ignore
            analytics.track('Updated Expert Submission', {
              profileId: profile?.id,
              data: payload,
            });
          }
        },
      )
      .subscribe();

    window.addEventListener('online', () => {
      setIsBecomeOnline(true);
      setIsBecomeOffline(false);
    });
    window.addEventListener('offline', () => {
      setIsBecomeOnline(false);
      setIsBecomeOffline(true);
    });

    return () => {
      expertVerificationSubmissions.unsubscribe();
    };
  }, []);

  useEffect(() => {
    setIsSlideChange(false);
  }, [window.location.pathname]);

  useEvents();
  return (
    <div className="App">
      {showModal && <Notification />}
      <AppRoutes />
      {showModal ? (
        <MessageModal
          title={showModal?.title}
          status={showModal?.type}
          onClick={() => setShowModal(null)}
          message={showModal?.message}
        />
      ) : null}
      {/* <SalesModal isOpen={isModalOpen} onClose={closeModal} /> */}
    </div>
  );
}

export default App;
